<template>
  <template v-if="mostrar_cadastro_perfil">
    <router-link v-if="isLoggedIn" class="menu-item destaque" to="/perfil">Meu cadastro</router-link>
    <router-link v-else class="menu-item destaque" to="/cadastro">Inscreva-se</router-link>
    <button @click="handleClick" class="menu-item destaque" :class="isLoggedIn ? 'sair' : 'entrar'">
      {{ isLoggedIn ? 'Sair' : 'Entrar' }}
    </button>
  </template>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from 'vue';
import { actions as keycloakActions } from '../modules/keycloak/storeKeycloak';
import KC from '@/security/keycloak';
import { UserSession } from '@/security/keycloak.d';
import util from '@/util';

export default defineComponent({
  name: 'LoginLogoutButton',
  setup() {
    const isLoggedIn = ref(false);
    const session = ref<UserSession>();
    const mostrar_cadastro_perfil = computed(() => util.get_mostrar_cadastro_perfil());

    const handleLogin = () => {
      const authHandlerUrl = `${window.location.origin}/auth-handler`;
      // console.log('Redirecionando para a página de login do Keycloak:', authHandlerUrl);
      keycloakActions.login({
        idpHint: 'govbr',
        redirectUri: authHandlerUrl,
      });
    };

    const handleLogout = async () => {
      try {
        // console.log('Fazendo logout...');
        await keycloakActions.logout();
        // Após o logout, verificar novamente a sessão
        ({ session: session.value, isLoggedIn: isLoggedIn.value } = KC.checkUserSession());
      } catch (error) {
        console.error('Erro ao fazer logout:', error);
      }
    };

    const handleClick = () => {
      if (isLoggedIn.value) {
        handleLogout();
      } else {
        handleLogin();
      }
    };

    onMounted(() => {
      ({ session: session.value, isLoggedIn: isLoggedIn.value } = KC.checkUserSession());

      // Adicionar listener para mudanças no localStorage
      const handleStorageChange = (event: StorageEvent) => {
        if (event.key === 'usuario-cnhsocial-web') {
          ({ session: session.value, isLoggedIn: isLoggedIn.value } = KC.checkUserSession());
        }
      };

      window.addEventListener('storage', handleStorageChange);

      // Cleanup listener quando o componente for desmontado
      return () => {
        window.removeEventListener('storage', handleStorageChange);
      };
    });

    return { handleClick, isLoggedIn, mostrar_cadastro_perfil };
  },
});
</script>
